import { Flame, Snowflake } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { StreakState } from '../../lib/streak'
import './HabitStreakBadge.scss'
import { WithTooltip } from '@/src/renderer/components/ui/tooltip'

interface HabitStreakBadgeProps {
  current: number
  state: StreakState
}

/**
 * Streak indicator: number + state icon.
 * - hot  → orange flame (streak alive, today done)
 * - frozen → ice cube / snowflake (a grace day covers a miss)
 * - cold → muted flame (today still open / at risk)
 * Renders nothing when there is no streak.
 */
export function HabitStreakBadge({ current, state }: HabitStreakBadgeProps) {
  const { t } = useTranslation()
  if (current <= 0) return null
  const Icon = state === 'frozen' ? Snowflake : Flame
  const label = state === 'frozen' ? t('habits.streak.frozen') : t('habits.streak.label', { count: current })
  return (
    <WithTooltip content={label}>
      <span className={`habit-streak habit-streak--${state}`} aria-label={label}>
        <span className="habit-streak__count">{current}</span>
        <Icon className="habit-streak__icon" size={14} aria-hidden />
      </span>
    </WithTooltip>
  )
}
